import A11yButton from './A11yButton'

export default class A11yButtonToggle extends A11yButton {
  constructor(element) {
    super(element)
    this.element.addEventListener('click', this.handleClick.bind(this))
  }

  handleClick(event) {
    const pressed = event.target.getAttribute('aria-pressed')
    this.element.setAttribute(
      'aria-pressed',
      pressed === 'true' ? 'false' : 'true',
    )
  }
}
